import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HandHeart, UserCheck, ShieldAlert, Smartphone, MessageSquareText } from 'lucide-react';
import { axiosInstance as axios } from '../../context/AuthContext';

const ITEMS = [
  { key: 'waiting_requests', label: 'Families waiting', tab: 'requests', Icon: HandHeart },
  { key: 'pending_applications', label: 'Applications to review', tab: 'applications', Icon: UserCheck },
  { key: 'open_reports', label: 'Open family reports', tab: 'oversight', Icon: ShieldAlert },
  { key: 'new_feedback', label: 'New feedback', path: '/feedback-dashboard', Icon: MessageSquareText },
];

export function AttentionStrip({ onOpenTab, refreshKey }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/admin/attention').then(r => setData(r.data)).catch(() => setData(null));
  }, [refreshKey]);

  if (!data) return null;
  const pushReady = data.push.android_ready || data.push.ios_ready;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6" data-testid="attention-strip">
      {ITEMS.map(({ key, label, tab, path, Icon }) => {
        const n = data[key];
        return (
          <button
            key={key}
            onClick={() => (path ? navigate(path) : onOpenTab(tab))}
            className={`text-left rounded-xl p-4 border transition-colors ${n ? 'bg-red-500/10 border-red-500/40 hover:bg-red-500/20' : 'bg-slate-800 border-slate-700 hover:bg-slate-700'}`}
            data-testid={`attention-${key}`}
          >
            <div className="flex items-center justify-between">
              <Icon className={`h-5 w-5 ${n ? 'text-red-300' : 'text-slate-500'}`} />
              <span className={`text-2xl font-bold ${n ? 'text-white' : 'text-slate-500'}`}>{n}</span>
            </div>
            <p className={`text-sm mt-2 ${n ? 'text-red-100' : 'text-slate-400'}`}>{label}</p>
          </button>
        );
      })}
      <div className="rounded-xl p-4 border bg-slate-800 border-slate-700" data-testid="attention-phone-alerts">
        <div className="flex items-center justify-between">
          <Smartphone className="h-5 w-5 text-slate-400" />
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${pushReady ? 'bg-green-500/20 text-green-300' : 'bg-amber-500/20 text-amber-300'}`}>
            {pushReady ? 'On' : 'Not set up'}
          </span>
        </div>
        <p className="text-sm mt-2 text-slate-400">
          {pushReady ? `Phone alerts · ${data.push.your_devices} of your phones` : 'Phone alerts need Apple/Google keys. You still get email + badge.'}
        </p>
      </div>
    </div>
  );
}
